import { gql } from '@apollo/client';

export const USER_AUTHORIZE_CODE_MUTATION = gql`
  mutation UserAuthorizeCode($codeChallenge: String!) {
    userAuthorizeCode(codeChallenge: $codeChallenge) {
      code
      username
      expiredAt
    }
  }
`;
